import React from "react";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import HoldAndWinIntroDialog from "../HoldAndWinIntroDialog/HoldAndWinIntroDialog";
import HoldAndWinReloadDialog from "../HoldAndWinReloadDialog/HoldAndWinReloadDialog";
import HoldAndWinOutroDialog from "../HoldAndWinOutroDialog/HoldAndWinOutroDialog";
import MaxWinDialog from "../MaxWinDialog/MaxWinDialog";
import FreeSpinIntroDialog from "../FreeSpin/FreeSpinIntroDialog/FreeSpinIntroDialog";
import FreeSpinOutroDialog from "../FreeSpin/FreeSpinOutroDialog/FreeSpinOutroDialog";
import FreeSpinRetriggerDialog from "../FreeSpin/FreeSpinRetriggerDialog/FreeSpinRetriggerDialog";

const Dialogs = () => {
  return (
    <>
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinIntroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinReloadDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinOutroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <MaxWinDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinIntroDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinOutroDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinRetriggerDialog />}
    </>
  );
};

export default Dialogs;

